import axios from "axios";

export default{
    install: (app, options) => {
            app.config.globalProperties.$fetchExternalContent = $fetchExternalContent;            
            app.provide('ExternalContilLoaderUtil', options);
        }
}

export async function $fetchExternalContent(contentUrl){
    try{       
        let clientId = parseInt(Math.random()*100000); 
        let rand = parseInt(Math.random()*100000)+""+parseInt(Math.random()*100000);
        let response = await axios.get(contentUrl,
            {
                headers:{ 'X-Client-Code': 'DataClient-'+clientId },
                params:{ code: rand }
            }
        ).then(res => res.data);        
        return response;
    }catch(error){
        return "";
    }
    
}
